import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import {
  handleGetApiGF,
  isWebView,
  rupeesFn,
  Toast,
  Userlogin,
} from "../Utils/general-function";
import useRazorpayPayment from "./useRazorpayPayment";
import DataTable from "react-data-table-component";
import { useForm } from "react-hook-form";
import * as z from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import Loader from "../Utils/Loader";
import TransactionList from "./TransactionList";

const schema = z.object({
  amount: z.coerce
    .number({
      invalid_type_error: "Amount must be a number",
    })
    .int("Only whole numbers allowed")
    .min(100, "Enter an amount between ₹100 and ₹20,000")
    .max(20000, "Enter an amount between ₹100 and ₹20,000"),
});
export const MyWallet = () => {
  const { status, handlePayment, PAYMENT_STATUS, retryPayment } =
    useRazorpayPayment();
  const [refreshkey, setRefreshKey] = useState(0); // State to trigger re-render transaction list after payment
  console.log("status", status);

  const {
    register,
    getValues,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({ defaultValues: { amount: "" }, resolver: zodResolver(schema) });

  const navigate = useNavigate();
  const [inputVal, setInput] = useState({
    balance: 12333,
  });
  const [loader, setLoader] = useState(true);

  const fetchWalletBalance = async () => {
    const res = await handleGetApiGF({
      url: "/api/WalletTransaction/GetAvailableWalletBalance",
    });
    if (res?.succ) {
      setInput((prev) => ({ ...prev, balance: res.data.Data || 0 }));
    }
    setLoader(false);
  };

  //METHOD
  useEffect(() => {
    if (!Userlogin()) navigate("/Login");
    fetchWalletBalance();
  }, []);

  console.log("status", status);

  const onSubmit = async (e) => {
    try {
      setLoader(true);
      let obj = new URLSearchParams({
        amount: e.amount,
      }).toString();

      const res = await handleGetApiGF({
        url: "/api/WalletTransaction/CreateOrder?" + obj,
      });

      if (!res?.succ) {
        Toast(
          false,
          "",
          res?.msg || "Failed to create order. Please try again.",
        );
        return;
      }
      await handlePayment({
        amount: e.amount,
        order_id: res?.data?.Data,
      });
    } catch (error) {
      console.error("err:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (status === PAYMENT_STATUS.SUCCESS) {
      // if success then clear input
      reset({ amount: "" });
      setRefreshKey((prev) => prev + 1); // Trigger re-render of TransactionList
      fetchWalletBalance();
    }
  }, [status, PAYMENT_STATUS, reset]);

  if (loader) return <Loader />;
  return (
    <>
      <Header />
      <div className="page-space">
        <div className="text-center">
          <h2 className="page-title">My Wallet</h2>
        </div>

        {/* input */}
        <div
          className="bg-white P-4"
          style={{
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            padding: "18px",
          }}
        >
          <h3>
            Available Balance:{" "}
            <span className="text-danger">{rupeesFn(inputVal.balance)}</span>
          </h3>
          <div>
            {status !== PAYMENT_STATUS.PENDING && (
              <div className="form-div">
                <input
                  type="number"
                  placeholder="₹ Add Wallet Amount"
                  className="form-control"
                  {...register("amount")}
                />
                <span className="text-danger">{errors.amount?.message}</span>
              </div>
            )}
            <button
              type="submit"
              className="submitbtn text-center w-100"
              disabled={status === PAYMENT_STATUS.VERIFYING}
              onClick={
                status === PAYMENT_STATUS.PENDING
                  ? retryPayment
                  : handleSubmit(onSubmit)
              }
            >
              {/* Add Wallet */}
              {status === PAYMENT_STATUS.PENDING ? "Retry Payment" : "Pay Now"}
            </button>
          </div>
        </div>

        {/* <button
          type="submit"
          className="submitbtn mt-2"
          onClick={() => {
            window.location.href = "https://m.carthi.in/#/mywallet";
          }}
        >
       
          Pay on Safari
        </button> */}
        <div className="mt-3 text-center">
          {/* UI States */}
          {status === PAYMENT_STATUS.LOADING && <p>⏳ Processing...</p>}
          {status === PAYMENT_STATUS.VERIFYING && <p>🔐 Verifying...</p>}
          {status === PAYMENT_STATUS.SUCCESS && <p>✅ Payment Success</p>}
          {status === PAYMENT_STATUS.FAILED && <p>❌ Payment Failed</p>}
          {status === PAYMENT_STATUS.CANCELLED && <p>⚠️ Payment Cancelled</p>}
        </div>

        <TransactionList key={refreshkey} />
      </div>
    </>
  );
};
